export enum IMessageContainers {
  CampaignWelcomeText,
  CampaignWelcomeEmail,
  CandidateTextNow,
  CandidateEmailNow,
  CandidateScheduledText,
  CandidateScheduledEmail,
  BulkTextNow,
  BulkEmailNow,
  BulkScheduledText,
  BulkScheduledEmail,
  GroupTextNow,
  GroupEmailNow,
  GroupScheduledText,
  GroupScheduledEmail,
  None,
}
export enum ISnackBarSeverity {
  error = "error",
  warning = "warning",
  info = "info",
  success = "success",
}
export enum ISetMessageState {
  Scheduled = "Scheduled",
}
